import { render, staticRenderFns } from "./InvestorBenefits.vue?vue&type=template&id=ef724c12&scoped=true&"
import script from "./InvestorBenefits.vue?vue&type=script&lang=ts&"
export * from "./InvestorBenefits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef724c12",
  null
  
)

export default component.exports